import { Paper } from '@mui/material'
import React from 'react'

export default function InfoCard({children,height}) {
  return (
    <Paper
      elevation={0}
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        p: 2,
        borderRadius: '12px',
        border: '1px solid #E0E0E0',
        height: height?height:null,
        backgroundColor: '#ffffff',
      }}
    >{children}</Paper>
  )
}
